/* ============================================================
   CAM - Barre d'achat persistante.

   PRINCIPE : la barre ne recalcule RIEN. Elle delegue au bouton de la
   zone d'achat (`[data-cam-cta]`), qui porte deja la variante choisie,
   l'offre, la quantite et le paiement direct. Un seul moteur d'achat
   sur la page = aucun risque de double ajout, de mauvaise variante ni
   de mauvaise quantite. Le prix et la vignette sont de simples miroirs.
   ============================================================ */
(function () {
  'use strict';

  var MARQUE = 'camStickyPret';

  function brancher(barre) {
    var hero = document.querySelector('.cam-s1');
    if (!hero) { barre.setAttribute('hidden', 'hidden'); return; }

    var ctaHero = hero.querySelector('[data-cam-cta]');
    if (!ctaHero) { barre.setAttribute('hidden', 'hidden'); return; }

    var ctaBarre = barre.querySelector('[data-cam-scta]');
    var nowBarre = barre.querySelector('[data-cam-snow]');
    var wasBarre = barre.querySelector('[data-cam-swas]');
    var imgBarre = barre.querySelector('[data-cam-simg]');

    var nowHero = hero.querySelector('[data-cam-now]');
    var wasHero = hero.querySelector('[data-cam-was]');

    function refletPrix() {
      if (nowBarre && nowHero) { nowBarre.textContent = nowHero.textContent; }
      if (wasBarre && wasHero) {
        wasBarre.hidden = wasHero.hidden;
        wasBarre.textContent = wasHero.textContent;
      }
    }

    /* La vignette suit la diapositive courante, reperee par la puce active
       (les puces restent dans le DOM en desktop, seulement masquees). */
    function refletImage() {
      if (!imgBarre) { return; }

      var diapos = hero.querySelectorAll('[data-cam-slide]');
      var puces = hero.querySelectorAll('[data-cam-dot]');
      var actif = null;

      for (var i = 0; i < puces.length; i++) {
        if (puces[i].getAttribute('aria-current') === 'true') {
          if (diapos[i]) { actif = diapos[i].querySelector('img'); }
          break;
        }
      }

      if (!actif) { actif = hero.querySelector('[data-cam-slide] img'); }
      if (!actif) { return; }

      var src = actif.currentSrc || actif.src;
      if (src && imgBarre.src !== src) { imgBarre.src = src; }
    }

    if (window.MutationObserver) {
      var obs = new window.MutationObserver(function () {
        refletPrix();
        refletImage();
      });
      if (nowHero) { obs.observe(nowHero, { childList: true, characterData: true, subtree: true }); }
      if (wasHero) { obs.observe(wasHero, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] }); }

      var listePuces = hero.querySelector('[data-cam-dots]');
      if (listePuces) { obs.observe(listePuces, { attributes: true, subtree: true, attributeFilter: ['aria-current'] }); }
    }

    /* Filet de securite : un clic dans la zone d'achat declenche un rendu,
       on relit juste apres, puis a nouveau apres le defilement lisse. */
    hero.addEventListener('click', function () {
      window.setTimeout(function () { refletPrix(); refletImage(); }, 30);
      window.setTimeout(function () { refletImage(); }, 450);
    });

    refletPrix();
    refletImage();

    if (ctaBarre) {
      ctaBarre.addEventListener('click', function (e) {
        e.preventDefault();
        ctaHero.click();
      });
    }

    /* ---------- Visibilite ---------- */

    var repere = ctaHero;
    /* Rappel final d'une section ulterieure : s'il est a l'ecran, la barre
       s'efface pour ne pas doubler le bouton. Absent aujourd'hui. */
    var rappelFinal = document.querySelector('[data-cam-final]');

    function afficher(oui) {
      barre.setAttribute('data-cam-visible', oui ? 'true' : 'false');
    }

    function hauteurEcran() {
      return window.innerHeight || document.documentElement.clientHeight || 0;
    }

    function finalAlEcran() {
      if (!rappelFinal) { return false; }
      var r = rappelFinal.getBoundingClientRect();
      return r.top < hauteurEcran() && r.bottom > 0;
    }

    function calculer() {
      var r = repere.getBoundingClientRect();
      afficher(r.bottom < 0 && !finalAlEcran());
    }

    /* Les DEUX mecanismes sont gardes : l'IntersectionObserver reagit vite,
       le listener de defilement couvre les cas ou l'observateur ne se
       declenche pas (volet non rendu, ancrage direct). */
    if (window.IntersectionObserver) {
      var io = new window.IntersectionObserver(function () { calculer(); }, {
        threshold: [0, 0.01, 1]
      });
      io.observe(repere);
      if (rappelFinal) { io.observe(rappelFinal); }
    }

    var dernier = 0;
    window.addEventListener('scroll', function () {
      var t = Date.now();
      if (t - dernier < 80) { return; }
      dernier = t;
      calculer();
    }, { passive: true });

    window.addEventListener('resize', calculer, { passive: true });
    calculer();
  }

  function init(racine) {
    var portee = racine && racine.querySelectorAll ? racine : document;
    Array.prototype.forEach.call(portee.querySelectorAll('[data-cam-sticky]'), function (b) {
      if (b.dataset[MARQUE] === '1') { return; }
      b.dataset[MARQUE] = '1';
      brancher(b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cam-sticky]')) { init(e.target); }
  });
})();